import React from 'react'

function Email(){
    return (
        <div>Welcome to Email page!</div>
    )
}
export default Email